import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchRequests, fetchRequest, createRequest, cancelRequest, deleteRequest } from './api';
import type { BookingDraft } from '../../shared/types/app';

export const REQUESTS_KEY = ['requests'] as const;

export function useRequests(params?: { status?: string; page?: number; limit?: number }) {
  return useQuery({
    queryKey: [...REQUESTS_KEY, params],
    queryFn: () => fetchRequests(params),
  });
}

export function useRequest(id: string) {
  return useQuery({
    queryKey: [...REQUESTS_KEY, id],
    queryFn: () => fetchRequest(id),
    enabled: !!id,
  });
}

export function useCreateRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (draft: BookingDraft) => createRequest(draft),
    onSuccess: () => qc.invalidateQueries({ queryKey: REQUESTS_KEY }),
  });
}

export function useCancelRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => cancelRequest(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: REQUESTS_KEY }),
  });
}

export function useDeleteRequest() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteRequest(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: REQUESTS_KEY }),
  });
}

